import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=180f971a&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=180f971a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180f971a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180f971a')) {
      api.createRecord('180f971a', component.options)
    } else {
      api.reload('180f971a', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=180f971a&scoped=true&", function () {
      api.rerender('180f971a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ef95sz9CSqZp/JS/comp/PopupDialog.vue"
export default component.exports